//@ts-check

import {
    getYear, getISODay, getMonth, getDate,
    setISODay, startOfWeek, endOfWeek, endOfMonth,
    format, parse, isSameDay, eachDay
} from 'date-fns';
import locale from 'date-fns/locale/cs';

const weekStartsOn = 1;

function toDate(date) {
    return (date instanceof Date) ? date : parse(date);
}

export default {
    toDate: (date) => toDate(date),
    getYear: (date) => getYear(toDate(date)),
    getMonth: (date) => getMonth(toDate(date)),
    getDate: (date) => getDate(toDate(date)),
    getDay: (date) => getISODay(toDate(date)),
    setDay: (date, day) => setISODay(toDate(date), day),
    startOfWeek: (date) => startOfWeek(toDate(date), { weekStartsOn }),
    endOfWeek: (date) => endOfWeek(toDate(date), { weekStartsOn }),
    endOfMonth: (date) => endOfMonth(toDate(date)),
    isSameDay: (date1, date2) => isSameDay(toDate(date1), toDate(date2)),
    eachDay: (date1, date2) => eachDay(toDate(date1), toDate(date2)),
    format: (date, formatString) => format(toDate(date), formatString, { locale }),

    FORMAT_DATE_ISO8601: 'YYYY-MM-DD',
    FORMAT_DATE_HUMAN: 'D. M. YYYY',
    FORMAT_TIME_HUMAN: 'H:mm',
    FORMAT_DATETIME_HUMAN: 'D. M. YYYY H:mm',
    FORMAT_WEEKDAY_NAME: 'dddd',
};
